/* Native search: Shopify storefront filtering for collection + search pages.
   Replaces the Boost filter scripts. Builds the URL from the filter form, the sort
   select and the per-page select. Filter ticks update the page in place; sort and per-page reload it.
   - Sold-out products are always left out: filter.v.availability=1 is added to every
     collection/search URL that lacks it (an inline script in layout/theme.liquid does
     this before the page draws; this is the fallback). That keeps the count and the
     pages exact, like Boost. Products set to "continue selling" count as available.
   - Merged tick boxes (data-values) select every spelling of a value at once. */
(function () {
  'use strict';
  var AVAIL = 'filter.v.availability';

  // only where the page still holds sold-out products (layout/theme.liquid sets NATIVE_AVAIL)
  var NEEDS_AVAIL = window.NATIVE_AVAIL !== false;
  function withAvailability(params) {
    if (NEEDS_AVAIL && !params.has(AVAIL)) params.append(AVAIL, '1');
    return params;
  }

  function go(params) {
    params.delete('page');
    withAvailability(params);
    var qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }

  var current = new URLSearchParams(window.location.search);
  if (NEEDS_AVAIL && !current.has(AVAIL)) {
    window.location.replace(window.location.pathname + '?' + withAvailability(current).toString());
    return;
  }
  // the in-stock filter stays in the page, not in the address people see, copy and bookmark
  // (Nathan, 2026-10-09). Our own links add it back (withAvailability) where it is needed.
  function cleanAddress() {
    var p = new URLSearchParams(window.location.search);
    if (!p.has(AVAIL)) return;
    p.delete(AVAIL);
    var qs = p.toString();
    try { history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) {}
  }
  cleanAddress();

  // Filter values must match exactly, but old links (Boost, menus) spell some differently:
  // "Core" for "CORE", "8" for "8.0", "T-Shirts" for "T-Shirt". Swap each for the value the filters really offer, once.
  function fixSpelling() {
    var known = {};
    document.querySelectorAll('[data-native-facets] input[data-param][data-values]').forEach(function (box) {
      var k = box.getAttribute('data-param');
      (known[k] = known[k] || []).push.apply(known[k], box.getAttribute('data-values').split('||'));
    });
    var norm = function (s) { var n = String(s).trim().toLowerCase(); return /^\d+(\.\d+)?$/.test(n) ? String(parseFloat(n)) : n.replace(/s$/, ''); };
    var out = new URLSearchParams(), changed = false;
    current.forEach(function (v, k) {
      var list = known[k];
      if (list && list.indexOf(v) === -1) {
        var hit = list.filter(function (x) { return norm(x) === norm(v); })[0];
        if (hit) { out.append(k, hit); changed = true; return; }
      }
      out.append(k, v);
    });
    if (changed) window.location.replace(window.location.pathname + '?' + out.toString());
    return changed;
  }
  if (fixSpelling()) return;

  // Express Shipping switch next to the Filter button: one tap shows only what can go next day.
  // It works the Delivery filter's own tick box, so the two always agree.
  function expressSwitch() {
    // every Delivery value counts (while Shopify's index catches up, old "Next Day" / "Express
    // Delivery" spellings sit beside "Express Shipping")
    var boxes = [].slice.call(document.querySelectorAll('[data-native-facets] input[data-param="filter.p.m.filter.delivery"]'));
    var bar = document.querySelector('.tt-filters-options');
    if (!boxes.length || !bar || document.querySelector('.native-express')) return;
    var key = boxes[0].getAttribute('data-param'), vals = [], n = 0;
    boxes.forEach(function (box) {
      box.getAttribute('data-values').split('||').forEach(function (v) { if (v !== '' && vals.indexOf(v) === -1) vals.push(v); });
      var c = box.closest('label') && box.closest('label').querySelector('.native-facets__count');
      n = Math.max(n, c ? parseInt(c.textContent.replace(/\D/g, ''), 10) || 0 : 0);   // the largest: old and new spellings overlap
    });
    var on = boxes.some(function (box) { return box.checked; });
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'native-express';
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('role', 'switch');
    b.setAttribute('aria-checked', on ? 'true' : 'false');
    b.innerHTML = '<span class="native-express__dot" aria-hidden="true"></span><span class="native-express__label">Express Shipping' +
      '<span class="native-express__only"> only</span>' + (!on && n ? ' <span class="native-express__count">(' + n + ')</span>' : '') + '</span>';
    b.addEventListener('click', function () {
      var params = new URLSearchParams(window.location.search);
      var keep = params.getAll(key).filter(function (v) { return vals.indexOf(v) === -1; });
      params.delete(key);
      keep.forEach(function (v) { params.append(key, v); });
      if (!on) vals.forEach(function (v) { params.append(key, v); });
      go(params);
    });
    // straight after the Filter button (or first, where there is none)
    var after = bar.querySelector('.tt-btn-toggle');
    if (after) after.parentNode.insertBefore(b, after.nextSibling); else bar.insertBefore(b, bar.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', expressSwitch);
  else expressSwitch();

  // A short chip label from a link's text ("Skateboard Bundles | Wheels & Bearing Packs" -> "Wheels & Bearing Packs").
  // Page titles and breadcrumbs show the collection title as typed since 2026-10-16; this is for the chips only
  function shortTitle(t) {
    var parts = String(t).split('|').map(function (x) { return x.trim(); });
    // short capitals are names (MOB, OJ, SFR, CORE): keep them; soften the rest (CLOTHING -> Clothing)
    var tc = function (x) { return x === x.toUpperCase() ? x.split(' ').map(function (w) { return w.length > 4 ? w.charAt(0) + w.slice(1).toLowerCase() : w; }).join(' ') : x; };
    var before = tc(parts[0]), name = parts[parts.length - 1];
    if (parts.length > 1 && /^all /i.test(name)) return before;
    name = name.split(' – ')[0].replace(/ For /g, ' for ');
    var f = name.split(' for ');
    if (f.length > 1 && f[f.length - 1].indexOf(',') !== -1) name = f[0];
    if (name.indexOf(' - ') !== -1) {
      var items = name.split(' - ').map(function (x) { return x.trim(); });
      name = parts.length > 1 && /['’]s$/.test(items[0]) ? items[0] + ' ' + before : items.join(', ');
    }
    name = name.replace(/!/g, '').trim();
    if (parts.length > 1 && /^(completes|decks|wheels|trucks|bearings|parts|accessories|hardware)$/i.test(name)) name = before + ' ' + name;
    return tc(name).replace('& MORE', '& More');
  }

  // Collection page header, kept to three things (2026-10-08, "a bit cluttered"):
  //   1. the title and product count on one line, with the description's opening line under it
  //      (written by snippets/collection-template.liquid, as is the full text below the products);
  //   2. ONE sliding row of chips: Filter, Express Shipping, Sort, then the page's own shortcut
  //      buttons (Popular Deck Widths, Related collections), the one in use highlighted. This script
  //      builds the row; without it those buttons simply stay where the description puts them;
  //   3. the products.
  function tidyHeader() {
    var bar = document.querySelector('.tt-filters-options');
    if (!bar || !document.querySelector('.native-coll-head') || document.querySelector('.native-chips')) return;
    var cnt = document.querySelector('.native-coll-count');
    if (cnt && /^0\s/.test(cnt.textContent.trim())) { bar.hidden = true; bar.style.setProperty('display', 'none', 'important'); return; }   // nothing to filter or sort
    var links = [].slice.call(document.querySelectorAll('[data-native-desc] a.collection-box, .collection-sub-links a.collection-box'));
    var here = function (u) {
      var out = {};
      new URLSearchParams(u).forEach(function (v, k) {
        k = k.replace(/^pf_m_::([^:]+)::/, 'filter.p.m.$1.');
        if (k.indexOf('filter.') === 0 && k !== 'filter.v.availability') (out[k] = out[k] || []).push(String(parseFloat(v) || v));
      });
      return Object.keys(out).sort().map(function (k) { return k + '=' + out[k].sort().join(','); }).join('&');
    };
    var now = here(window.location.search);
    var nowMap = {};
    if (now) now.split('&').forEach(function (part) { var kv = part.split('='); nowMap[kv[0]] = kv[1].split(','); });
    var chips = document.createElement('div');
    chips.className = 'native-chips';
    links.forEach(function (a) {
      var row = a.closest('[class*="flex-"], .collection-sub-links');
      if (row) row.setAttribute('data-moved', '');
      try {
        var u = new URL(a.href, window.location.href);
        // on when everything the chip filters by is on (other filters, e.g. Express Shipping, may be too)
        var mine = here(u.search);
        if (u.pathname === window.location.pathname && mine && mine.split('&').every(function (part) {
          var kv = part.split('='), want = kv[1].split(','), got = (nowMap[kv[0]] || []);
          return want.every(function (v) { return got.indexOf(v) !== -1; });
        })) a.classList.add('is-active');
      } catch (e) {}
      // the shop name, like the page titles: "Skateboard Bundles | Wheels & Bearing Packs" -> "Wheels & Bearing Packs"
      a.textContent = shortTitle(a.textContent.replace(/\s+/g, ' ').trim());
      chips.appendChild(a);
    });
    // the little "Popular Deck Widths:" heading above a moved row has nothing left to label
    document.querySelectorAll('[data-native-desc] [data-moved]').forEach(function (row) {
      var prev = row.previousElementSibling, last = prev && prev.lastElementChild;
      if (last && /^H[1-6]$/.test((last.firstElementChild || last).tagName) && last.textContent.trim().length < 60) last.setAttribute('hidden', '');
    });
    if (chips.children.length) {
      var sort = bar.querySelector('.option-select-wrapper');
      if (sort) sort.parentNode.insertBefore(chips, sort.nextSibling); else bar.appendChild(chips);
    }
    // the Filter chip says how many filters are on ("Filter (2)"): on a phone the panel is closed
    var on = {};
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (/^filter\.(p|v)\./.test(k) && k !== 'filter.v.availability') on[k === 'filter.p.m.filter.delivery' ? k : k + '=' + v] = 1;   // Delivery counts once
    });
    var n = Object.keys(on).length, fbtn = bar.querySelector('.tt-btn-toggle a');
    if (n && fbtn && !fbtn.querySelector('.native-filter-n')) {
      var badge = document.createElement('span');
      badge.className = 'native-filter-n';
      badge.textContent = n;
      fbtn.appendChild(badge);
    }
    // and the chip row slides so the highlighted size or collection is in view
    var act = chips.querySelector('.is-active');
    if (act) { var row = window.innerWidth <= 1024 ? chips : bar; row.scrollLeft = Math.max(0, act.offsetLeft - row.offsetLeft - row.clientWidth / 2 + act.offsetWidth / 2); }

    // "Read more" opens the whole description right there under the title; "Read less" closes it
    var about = document.querySelector('[data-native-about]');
    if (about) {
      var moreBtn = about.querySelector('.native-coll-intro__more');
      var setOpen = function (open) {
        about.classList.toggle('is-open', open);
        if (moreBtn) moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) about.scrollIntoView({ block: 'nearest' });
      };
      if (moreBtn) moreBtn.addEventListener('click', function () { setOpen(true); });
      var lessBtn = about.querySelector('.native-coll-intro__less');
      if (lessBtn) lessBtn.addEventListener('click', function () { setOpen(false); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidyHeader);
  else tidyHeader();

  function formParams(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '' && k) params.append(k, v); });
    form.querySelectorAll('input[data-values]:checked').forEach(function (box) {
      box.getAttribute('data-values').split('||').forEach(function (v) {
        if (v !== '') params.append(box.getAttribute('data-param'), v);
      });
    });
    var cur = new URLSearchParams(window.location.search);
    ['view'].forEach(function (k) { if (cur.has(k) && !params.has(k)) params.set(k, cur.get(k)); });
    return params;
  }

  function initSlider(form) {
    var box = form.querySelector('[data-price-slider]');
    if (!box) return;
    var lo = box.querySelector('[data-lo]'), hi = box.querySelector('[data-hi]');
    var fill = box.querySelector('.native-facets__fill');
    var nums = form.querySelectorAll('.native-facets__price input[type=number]');
    var max = parseFloat(box.getAttribute('data-max')) || 0;
    function paint() {
      var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
      fill.style.left = (max ? a / max * 100 : 0) + '%';
      fill.style.right = (max ? 100 - b / max * 100 : 0) + '%';
      if (nums[0]) nums[0].value = a > 0 ? a : '';
      if (nums[1]) nums[1].value = b < max ? b : '';
    }
    [lo, hi].forEach(function (r) {
      r.addEventListener('input', function (e) { e.stopPropagation(); paint(); });
      r.addEventListener('change', function (e) { e.stopPropagation(); paint(); apply(form, formParams(form)); });
    });
    // typing in the boxes moves the handles
    nums.forEach(function (n, i) {
      n.addEventListener('input', function () {
        var v = n.value === '' ? (i ? max : 0) : +n.value;
        (i ? hi : lo).value = v;
        var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
        fill.style.left = (max ? a / max * 100 : 0) + '%';
        fill.style.right = (max ? 100 - b / max * 100 : 0) + '%';
      });
    });
    var a = Math.min(+lo.value, +hi.value), b = Math.max(+lo.value, +hi.value);
    fill.style.left = (max ? a / max * 100 : 0) + '%';
    fill.style.right = (max ? 100 - b / max * 100 : 0) + '%';
  }


  /* ---------- sizes: merge spellings of the same size, then order S, M, L, XL (shoe sizes junior then adult) ---------- */
  var WORDS = [[/\bextra[\s-]*small\b|\bx[\s-]*small\b|\bxsmall\b/g, 'xs'], [/\bextra[\s-]*large\b|\bx[\s-]*large\b|\bxlarge\b/g, 'xl'],
    [/\bxx[\s-]*large\b/g, 'xxl'], [/\bxx[\s-]*small\b/g, 'xxs'], [/\bsmalll?\b|\bsml\b/g, 's'], [/\bmedium\b|\bmed\b/g, 'm'], [/\blarge\b|\blge\b/g, 'l'], [/\b(?:jr|jnr)\b/g, 'junior']];
  var LETTER = { xxxs: 1, xxs: 2, xs: 3, s: 4, m: 5, l: 6, xl: 7, xxl: 8, xxxl: 9, '2xl': 8, '3xl': 9 };
  function canonSize(label) {
    var t = label.toLowerCase().replace(/[()"″]/g, ' ');
    WORDS.forEach(function (w) { t = t.replace(w[0], w[1]); });
    t = t.replace(/\s*(?:\/|–|-|\bto\b)\s*/g, '/').replace(/\s+/g, ' ').trim();
    t = t.replace(/\/uk\s*/g, '/');                    // "uk 3/uk 6.5" -> "uk 3/6.5"
    t = t.replace(/^uk\s+/, 'uk');
    return t;
  }
  function one(t) {
    t = t.trim();
    if (LETTER[t] != null) return LETTER[t] - 100;
    var uk = t.match(/^(?:uk\s*)?(\d+(?:\.\d+)?)\s*(j?)$/);          // uk13j, uk5, 9.5
    if (uk) return uk[2] ? +uk[1] - 20 : +uk[1];
    var lead = t.match(/^(xxxs|xxs|xs|s|m|l|xl|xxl|xxxl)\b/);         // "l 20 50.8cm" -> l
    if (lead) return LETTER[lead[1]] - 100;
    var n = t.match(/^(\d+(?:\.\d+)?)/);                              // 8.25, 52mm, 14", 55cm
    if (n) return +n[1];
    return null;
  }
  function sizeRank(label) {
    var t = canonSize(label.replace(/\([^)]*\)/g, ' '));   // "XS (4-8 years)" -> "XS"
    t = t.replace(/\b\d+(?:\.\d+)?\s*(?:years?|yrs?)\b/g, '').replace(/\/+$/, '').trim();
    if (/^(one size|osfa|os|one size fits all)$/.test(t)) return 10000;
    var young = /\b(youth|junior|jnr|jr|kids?|y)\b/.test(t) ? -1000 : 0;
    var adult = /\badult\b/.test(t) ? 500 : 0;
    t = t.replace(/\b(youth|junior|jnr|jr|kids?|adult|pads?|helmet|size|long|short)\b/g, '').trim();
    var parts = t.split('/').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!parts.length) return (young || adult) ? young + adult : null;
    var ranks = parts.map(one);
    if (ranks.some(function (r) { return r == null; })) return null;
    return young + adult + ranks.reduce(function (a, b) { return a + b; }, 0) / ranks.length;
  }
  var KEEP_ORDER = /^(brand|colou?r|product type)$/i;
  function countOf(li) { var c = li.querySelector('.native-facets__count'); return c ? parseInt(c.textContent.replace(/\D/g, ''), 10) || 0 : 0; }
  // fold li `b` into li `a`: one tick box selects every spelling
  function fold(a, b) {
    var ia = a.querySelector('input[data-values]'), ib = b.querySelector('input[data-values]');
    if (!ia || !ib) return false;
    ia.setAttribute('data-values', ia.getAttribute('data-values') + ib.getAttribute('data-values'));
    if (ib.checked) ia.checked = true;
    if (ia.disabled && !ib.disabled) ia.disabled = false;
    var ca = a.querySelector('.native-facets__count');
    var total = countOf(a) + countOf(b);
    if (countOf(b) > countOf(a)) a.querySelector('.native-facets__label').textContent = b.querySelector('.native-facets__label').textContent;
    if (ca) ca.textContent = '(' + total + ')';
    b.parentNode.removeChild(b);
    return true;
  }
  function plainKey(label) {   // Helmet / Helmets, Pad / Pads
    return label.toLowerCase().trim().replace(/(\w{4,})s$/, '$1');
  }
  function tidyList(group) {
    var title = ((group.querySelector('summary') || {}).textContent || '').trim();
    var list = group.querySelector('.native-facets__list');
    if (!list) return;
    var isSize = !KEEP_ORDER.test(title);
    // Deck widths group to the nearest 1/8" (how decks are sold): suppliers write 8.125 as 8.13,
    // 8.375 as 8.37 / 8.38 and quote in-between shapes (8.06, 8.45), which made ~78 options on
    // the Decks page (Nathan, 2026-10-09). Ticking "8.5" selects every width that rounds to it.
    var eighths = group.getAttribute('data-param') === 'filter.p.m.attribute.deck-width';
    var eighth = function (t) {
      var n = parseFloat(String(t).replace(/["″]/g, ''));
      if (isNaN(n) || !/^\s*\d+(\.\d+)?\s*["″]?\s*$/.test(t)) return null;
      var r = Math.round(n * 8) / 8;
      return r % 1 === 0 ? r.toFixed(1) : String(r);
    };
    var seen = {};
    [].slice.call(list.children).forEach(function (li) {
      var lab = li.querySelector('.native-facets__label');
      if (!lab) return;
      var t = lab.textContent.trim();
      if (/^default title$/i.test(t)) { li.parentNode.removeChild(li); return; }
      var w = eighths ? eighth(t) : null;
      var k = w ? 'w' + w : (isSize ? canonSize(t) : plainKey(t));
      if (seen[k] && seen[k] !== li) { fold(seen[k], li); }
      else seen[k] = li;
      if (w) seen[k].querySelector('.native-facets__label').textContent = w;
    });
    if (/^brand$/i.test(title)) {   // A to Z, numbers first ("2Cents", "411", "5Boro NYC", "Ace")
      [].slice.call(list.children).sort(function (a, b) {
        var la = a.querySelector('.native-facets__label'), lb = b.querySelector('.native-facets__label');
        return (la ? la.textContent.trim() : '').localeCompare(lb ? lb.textContent.trim() : '', 'en', { numeric: true, sensitivity: 'base' });
      }).forEach(function (li) { list.appendChild(li); });
      return;
    }
    if (!isSize) return;
    // order the sizes we understand; anything else keeps its place at the end
    var keyed = [].slice.call(list.children).map(function (li, i) {
      return { li: li, i: i, r: sizeRank(li.querySelector('.native-facets__label').textContent) };
    });
    keyed.sort(function (a, b) {
      if (a.r == null && b.r == null) return a.i - b.i;
      if (a.r == null) return 1;
      if (b.r == null) return -1;
      return a.r - b.r || a.i - b.i;
    });
    keyed.forEach(function (k) { list.appendChild(k.li); });
  }

  /* ---------- type-to-find box on long lists (Brand, Colour…) ---------- */
  function addFinder(group) {
    var list = group.querySelector('.native-facets__list');
    if (!list || list.children.length <= 10) return;
    var title = ((group.querySelector('summary') || {}).textContent || '').trim();
    var box = document.createElement('input');
    box.type = 'search';
    box.className = 'native-facets__find';
    box.placeholder = 'Search ' + title.toLowerCase();
    box.setAttribute('aria-label', 'Search ' + title);
    list.parentNode.insertBefore(box, list);
    box.addEventListener('input', function () {
      var q = box.value.trim().toLowerCase();
      [].forEach.call(list.children, function (li) {
        var lab = (li.querySelector('.native-facets__label') || li).textContent.toLowerCase();
        li.hidden = q !== '' && lab.indexOf(q) === -1;
      });
    });
    // typing in it must not submit the filter form
    box.addEventListener('change', function (e) { e.stopPropagation(); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  }

  /* ---------- phones: open only the first two sections (and any in use) ---------- */
  function foldForPhones(form) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 1024px)').matches) return;
    // On Sale and Delivery are one tick box each, so they stay open and don't use up the two
    var opened = 0;
    form.querySelectorAll('details.native-facets__group').forEach(function (d) {
      if (d.querySelectorAll('input[type="checkbox"]').length === 1 || d.querySelector('input:checked')) return;
      if (opened < 2) { opened++; return; }
      d.removeAttribute('open');
    });
  }


  /* ---------- colour swatches (copied from Boost's swatch settings, assets/native-swatches.json) ---------- */
  var BASIC = { black: '#000', white: '#fff', red: '#e01f2d', blue: '#1f71eb', green: '#0fb345', yellow: '#ffeb00', pink: '#ffc0cb',
    purple: '#800080', orange: '#ff8000', grey: '#b5b5b5', gray: '#b5b5b5', navy: '#000080', brown: '#ae733f', beige: '#f7f0da',
    teal: '#008080', mint: '#a5f9ec', lime: '#00ff00', gold: '#d4af37', silver: '#c0c0c0', cream: '#fff3d6', khaki: '#c3b091',
    burgundy: '#ae0735', maroon: '#800000', cyan: '#00bcd4', turquoise: '#40e0d0', clear: 'transparent', natural: '#e8d4ae', tan: '#d2b48c' };
  function swatchFor(label, map) {
    var t = label.toLowerCase().trim();
    if (map[t]) return map[t];
    var parts = t.split(/\s*\/\s*/);
    if (parts.length === 2) {
      var a = map[parts[0]] || (BASIC[parts[0]] && { c: [BASIC[parts[0]]] });
      var b = map[parts[1]] || (BASIC[parts[1]] && { c: [BASIC[parts[1]]] });
      if (a && b && a.c && b.c) return { c: [a.c[0], b.c[0]] };
    }
    var word = t.split(/[\s\/-]+/).reverse().find(function (w) { return map[w] || BASIC[w]; });
    if (word) return map[word] || { c: [BASIC[word]] };
    return null;
  }
  function addSwatches(form) {
    var groups = [].filter.call(form.querySelectorAll('details.native-facets__group'), function (g) {
      return /^colou?r$/i.test(((g.querySelector('summary') || {}).textContent || '').trim());
    });
    if (!groups.length || !window.fetch) return;
    var src = form.getAttribute('data-swatches');
    if (!src) return;
    fetch(src).then(function (r) { return r.json(); }).then(function (map) {
      groups.forEach(function (g) {
        g.querySelectorAll('.native-facets__option').forEach(function (opt) {
          var lab = opt.querySelector('.native-facets__label');
          var sw = swatchFor(lab.textContent, map);
          var dot = document.createElement('span');
          dot.className = 'native-facets__swatch';
          if (sw && sw.i) dot.style.backgroundImage = 'url(' + sw.i + ')';
          else if (sw && sw.c && sw.c.length > 1) dot.style.background = 'linear-gradient(135deg,' + sw.c[0] + ' 50%,' + sw.c[1] + ' 50%)';
          else if (sw && sw.c) dot.style.background = sw.c[0];
          else dot.classList.add('is-none');
          lab.parentNode.insertBefore(dot, lab);
        });
      });
    }).catch(function () {});
  }

  /* ---------- phones: each tick filters straight away, behind the open panel (2026-10-09) ----------
     Nathan, 2026-10-09: a tick has to filter by itself, people miss an apply button. So the
     products, count and page links behind the drawer are swapped for the new ones on every tick
     (and the address updated), and closing the drawer, however it is closed, just shows them.
     The button at the bottom only closes. Earlier notes, kept for why the drawer stays open: */
  /* ---------- phones: tick several, then "Show N results" (2026-10-08) ----------
     On a desktop a tick applies at once. In the phone drawer that closed the panel after every
     tick, so choosing a brand AND a width meant opening it twice. Here a tick fetches the new
     page in the background and swaps in its filter panel (fresh counts, empty options dropped),
     and the sticky button at the bottom of the drawer applies it. Closing the drawer with
     changes pending applies them too. */
  var PHONE = !!(window.matchMedia && window.matchMedia('(max-width: 1024px)').matches);
  var pending = null, seq = 0;
  function pageUrl(params) {
    params.delete('page');
    withAvailability(params);
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }
  function countText(doc) {
    var c = doc.querySelector('.native-coll-count');
    var n = c ? parseInt(c.textContent.replace(/[^\d]/g, ''), 10) : NaN;
    if (isNaN(n)) return 'Show results';
    if (/\+/.test(c.textContent)) return 'Show 1000+ results';
    return n === 1 ? 'Show 1 result' : 'Show ' + n + ' results';
  }
  function applyBar(form) {
    var aside = form.parentNode;
    var bar = aside.querySelector('.native-apply');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'native-apply';
      bar.innerHTML = '<button type="button" class="native-apply__btn"></button>';
      aside.appendChild(bar);
      bar.querySelector('button').addEventListener('click', function () {
        if (pending) { go(pending); return; }    // a tick still loading: just go there
        var close = aside.querySelector('.tt-btn-col-close a, .tt-btn-col-close');
        if (close) close.click();
      });
    }
    return bar.querySelector('button');
  }
  function preview(form, params) {
    var url = pageUrl(params), mine = ++seq, btn = PHONE ? applyBar(form) : null;
    pending = new URLSearchParams(url.split('?')[1] || '');
    if (btn) btn.textContent = 'Updating\u2026';
    form.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      if (mine !== seq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-native-facets]');
      if (btn) btn.textContent = countText(doc);
      form.classList.remove('is-loading');
      if (!fresh) return;
      var open = {};
      form.querySelectorAll('details.native-facets__group').forEach(function (d) {
        open[d.getAttribute('data-param') || d.querySelector('summary').textContent.trim()] = d.open;
      });
      var scroller = form.parentNode, top = scroller.scrollTop;
      form.innerHTML = fresh.innerHTML;
      decorate(form, open);
      scroller.scrollTop = top;
      showResults(doc, url);
    }).catch(function () { go(params); });
  }
  // put the fetched page's results behind the drawer, as if it had loaded
  function showResults(doc, url) {
    var swap = function (sel) {
      var a = document.querySelector(sel), b = doc.querySelector(sel);
      if (a && b) a.parentNode.replaceChild(document.importNode(b, true), a);
      return a || b;
    };
    swap('.tt-product-listing');
    var pa = document.querySelector('.native-pagination'), pb = doc.querySelector('.native-pagination');
    if (pa && pb) pa.parentNode.replaceChild(document.importNode(pb, true), pa);
    else if (pa) pa.parentNode.removeChild(pa);
    else if (pb) { var l = document.querySelector('.tt-product-listing'); if (l) l.parentNode.insertBefore(document.importNode(pb, true), l.nextSibling); }
    var ca = document.querySelector('.native-coll-count'), cb = doc.querySelector('.native-coll-count');
    if (ca && cb) ca.textContent = cb.textContent;
    // desktop: each tick is its own history step, as when it reloaded, so Back undoes it
    try { if (PHONE) history.replaceState(null, '', url); else { history.pushState({ nativeFilters: 1 }, '', url); stepped = true; } } catch (e) {}
    cleanAddress();
    pending = null;                      // already applied: closing the drawer just shows it
    refreshBar();
  }
  // the bits of the bar above the products that say what is on: Filter count, Express switch, chips
  function refreshBar() {
    var on = {};
    new URLSearchParams(window.location.search).forEach(function (v, k) {
      if (/^filter\.(p|v)\./.test(k) && k !== 'filter.v.availability') on[k === 'filter.p.m.filter.delivery' ? k : k + '=' + v] = 1;
    });
    var n = Object.keys(on).length, fbtn = document.querySelector('.tt-filters-options .tt-btn-toggle a');
    if (fbtn) {
      var badge = fbtn.querySelector('.native-filter-n');
      if (n && !badge) { badge = document.createElement('span'); badge.className = 'native-filter-n'; fbtn.appendChild(badge); }
      if (badge) { if (n) badge.textContent = n; else badge.parentNode.removeChild(badge); }
    }
    var ex = document.querySelector('.native-express');
    if (ex) ex.parentNode.removeChild(ex);
    expressSwitch();
    var cur = new URLSearchParams(window.location.search), norm = function (v) { return String(parseFloat(v) || v).toLowerCase(); };
    document.querySelectorAll('.native-chips a').forEach(function (a) {
      try {
        var u = new URL(a.href, window.location.href), want = [];
        new URLSearchParams(u.search).forEach(function (v, k) {
          k = k.replace(/^pf_m_::([^:]+)::/, 'filter.p.m.$1.');      // the chips are old Boost links
          if (k.indexOf('filter.') === 0 && k !== 'filter.v.availability') want.push([k, norm(v)]);
        });
        var hit = u.pathname === window.location.pathname && want.length && want.every(function (kv) {
          return cur.getAll(kv[0]).map(norm).indexOf(kv[1]) !== -1;
        });
        a.classList.toggle('is-active', !!hit);
      } catch (e) {}
    });
  }
  /* Desktop too, since 2026-10-14 (Boost filtered without a reload): a tick swaps the
     products, count, pagination and the filter panel in place instead of reloading the page. */
  function apply(form, params) { preview(form, params); }
  // Back/Forward over those in-place steps: load that address properly
  var stepped = false;
  window.addEventListener('popstate', function () { if (stepped) window.location.reload(); });

  function decorate(form, open) {
      initSlider(form);
      form.querySelectorAll('details.native-facets__group').forEach(function (g) { tidyList(g); addFinder(g); });
      if (open) {
        form.querySelectorAll('details.native-facets__group').forEach(function (d) {
          var k = d.getAttribute('data-param') || d.querySelector('summary').textContent.trim();
          d.open = (k in open) ? open[k] : !!d.querySelector('input:checked');
        });
      } else foldForPhones(form);
      // selected-filter tags: one tag per merged value (Helmet + Helmets, S + Small)
      var seenPill = {};
      form.querySelectorAll('.native-facets__pill[data-remove-param]').forEach(function (pill) {
        var param = pill.getAttribute('data-remove-param'), value = pill.getAttribute('data-remove-value');
        var box = [].filter.call(form.querySelectorAll('input[data-values]'), function (b) {
          return b.getAttribute('data-param') === param && b.getAttribute('data-values').split('||').indexOf(value) !== -1;
        })[0];
        var key = param + '|' + (box ? box.getAttribute('data-values') : value);
        if (seenPill[key]) { var li = pill.closest('li'); if (li) li.parentNode.removeChild(li); return; }
        seenPill[key] = true;
        if (box) {   // show the same label as the tick box
          var lab = box.closest('label').querySelector('.native-facets__label');
          var head = pill.firstChild && pill.firstChild.nodeType === 3 ? pill.firstChild : null;
          if (lab && head) head.textContent = head.textContent.replace(/:\s.*$/, ': ' + lab.textContent.trim() + ' ');
        }
      });
      addSwatches(form);
  }

  function init() {
    var form = document.querySelector('[data-native-facets]');
    if (form) {
      decorate(form);
      if (PHONE) {
        var c = document.querySelector('.native-coll-count');
        applyBar(form).textContent = c ? countText(document) : 'Show results';
        // while the drawer is open, Ollie's bubble would sit on top of the Show results button
        var aside = form.parentNode, mark = function () {
          document.documentElement.classList.toggle('native-drawer-open', aside.classList.contains('column-open'));
        };
        if (window.MutationObserver) new MutationObserver(mark).observe(aside, { attributes: true, attributeFilter: ['class'] });
        mark();
      }
      var timer;
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'number') {
          clearTimeout(timer);
          timer = setTimeout(function () { apply(form, formParams(form)); }, 700);
          return;
        }
        if (e.target && e.target.type === 'range') return;
        apply(form, formParams(form));
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); go(formParams(form)); });
      // a selected-filter tag removes every spelling of a merged value, not just one
      form.addEventListener('click', function (e) {
        var pill = e.target.closest && e.target.closest('[data-remove-param]');
        if (!pill) return;
        var param = pill.getAttribute('data-remove-param'), value = pill.getAttribute('data-remove-value');
        form.querySelectorAll('input[data-values]').forEach(function (box) {
          if (box.getAttribute('data-param') === param && box.getAttribute('data-values').split('||').indexOf(value) !== -1) {
            e.preventDefault(); box.checked = false; apply(form, formParams(form));
          }
        });
      });
    }

    var sort = document.querySelector('[data-native-sort]');
    if (sort) sort.addEventListener('change', function () {
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', sort.value);
      go(p);
    });

    var limit = document.querySelector('[data-native-limit]');
    if (limit) limit.addEventListener('change', function () {
      var p = new URLSearchParams(window.location.search);
      if (limit.value === '16' || limit.value === '32') p.set('view', limit.value);
      else p.delete('view');
      go(p);
    });
  }

  // The shortcut chips sit inside the theme's filter toolbar (.tt-filters-options), whose old
  // Boost-era script swallows clicks on links in it, so a tapped chip went nowhere (Nathan,
  // 2026-10-09). Caught first, at the document, and followed here.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.native-chips a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = a.href;
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
